const bedSizeConst = {
  uk: [
    {
      type: 'single_bed',
      width: 90,
      length: 190,
    },
    {
      type: 'small_double_bed',
      width: 125,
      length: 190,
    },
    {
      type: 'double_bed',
      width: 135,
      length: 190,
    },
    {
      type: 'king_size_bed',
      width: 200,
      length: 200,
    },
    {
      type: 'bunk_bed',
      width: null,
      length: null,
    },
    {
      type: 'twin_bed',
      width: null,
      length: null,
    },
    {
      type: 'not_specific',
      width: null,
      length: null,
    },
  ],
  au: [
    {
      type: 'single_bed',
      width: 92,
      length: 180,
    },
    {
      type: 'king_single_bed',
      width: 107,
      length: 203,
    },
    {
      type: 'double_bed',
      width: 138,
      length: 188,
    },
    {
      type: 'queen_bed',
      width: 153,
      length: 203,
    },
    {
      type: 'king_bed',
      width: 183,
      length: 203,
    },
    {
      type: 'california_king_bed',
      width: 183,
      length: 213,
    },
    {
      type: 'grand_king_bed',
      width: 203,
      length: 203,
    },
    {
      type: 'bunk_bed',
      width: null,
      length: null,
    },
    {
      type: 'twin_bed',
      width: null,
      length: null,
    },
    {
      type: 'not_specific',
      width: null,
      length: null,
    },
  ],
  us: [
    {
      type: 'single_bed',
      width: 97,
      length: 191,
    },
    {
      type: 'double_bed',
      width: 137,
      length: 191,
    },
    {
      type: 'queen_bed',
      width: 152,
      length: 203,
    },
    {
      type: 'king_bed',
      width: 193,
      length: 203,
    },
    {
      type: 'bunk_bed',
      width: null,
      length: null,
    },
    {
      type: 'twin_bed',
      width: null,
      length: null,
    },
    {
      type: 'not_specific',
      width: null,
      length: null,
    },
  ],
  common: [
    {
      type: 'single_bed',
      width: null,
      length: null,
    },
    {
      type: 'double_bed',
      width: null,
      length: null,
    },
    {
      type: 'small_double_bed',
      width: null,
      length: null,
    },
    {
      type: 'king_bed',
      width: null,
      length: null,
    },
    {
      type: 'king_single_bed',
      width: null,
      length: null,
    },
    {
      type: 'california_king_bed',
      width: null,
      length: null,
    },
    {
      type: 'grand_king_bed',
      width: null,
      length: null,
    },
    {
      type: 'queen_bed',
      width: null,
      length: null,
    },
    {
      type: 'bunk_bed',
      width: null,
      length: null,
    },
    {
      type: 'twin_bed',
      width: null,
      length: null,
    },
    {
      type: 'not_specific',
      width: null,
      length: null,
    },
  ],
};

export default bedSizeConst;
